var exports = {
  "n": "xcc377c0b--29459a--link",
  "U": "xcc377c0b--29459a--arrow",
};

module.exports = exports;
